import React, { AnchorHTMLAttributes, forwardRef } from 'react';
import {
  ContentWrapper,
  StyledEmoji,
  StyledIcon,
  StyledLinkCard,
  StyledText
} from './styled';
import { Icon, IconName } from '../icons';
import { IconWrapper } from '../button/styled';
import { JustifyContent } from '@payflip/types/product-builder';

export interface LinkCardProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  icon?: JSX.Element | IconName | null;
  emoji?: string;
  fullWidth?: boolean;
  contentLayout?: JustifyContent;
  iconPosition?: 'left' | 'right';
  allowTextWrap?: boolean;
  openInNewTab?: boolean;
}

export const LinkCard = forwardRef<HTMLAnchorElement, LinkCardProps>(
  (
    {
      children,
      icon,
      emoji,
      allowTextWrap = false,
      fullWidth = false,
      contentLayout = 'stretch',
      iconPosition = 'right',
      openInNewTab = true,
      ...props
    },
    ref
  ): JSX.Element => {
    let iconOrImage;

    if (typeof icon === 'string') {
      iconOrImage = icon.includes('http') ? (
        <IconWrapper position={iconPosition}>
          <img src={icon} alt="company logo" />
        </IconWrapper>
      ) : (
        <IconWrapper position={iconPosition}>
          <Icon name={icon} />
        </IconWrapper>
      );
    } else {
      iconOrImage = <StyledIcon>{icon}</StyledIcon>;
    }

    let emojiOrImage;

    if (typeof emoji === 'string') {
      emojiOrImage = emoji.includes('http') ? (
        <IconWrapper position={iconPosition}>
          <img src={emoji} alt="company logo" />
        </IconWrapper>
      ) : (
        emoji
      );
    } else {
      iconOrImage = null;
    }

    return (
      <StyledLinkCard
        ref={ref}
        {...props}
        $fullWidth={fullWidth}
        $contentLayout={contentLayout}
        target={openInNewTab ? '_blank' : '_parent'}
      >
        <ContentWrapper>
          <StyledEmoji>{emojiOrImage}</StyledEmoji>
          <StyledText allowTextWrap={allowTextWrap}>{children}</StyledText>
        </ContentWrapper>
        {iconOrImage}
      </StyledLinkCard>
    );
  }
);
